<app-nomenclature [addNewEntityButtonLabel]="'Adauga companie transport'" (addNewEntityEvent)="addNewEntity()"></app-nomenclature>
<p-divider></p-divider>
<p>Companii de transport</p>
<p-divider></p-divider>

<div class="grid">
    <div class="col-12">
        <div class="card">
            <app-stt-table #table
                           [endpoint]="tableEndpoint" [expandComponent]="expandComponent"
                           [actionTemplate]="tableActionComponent"
                           [query]="tableQuery">
            </app-stt-table>
        </div>
    </div>
</div>

<p-confirmDialog [style]="{width: '50vw'}" [baseZIndex]="10000" appendTo="body" closeOnEscape="true" dismissableMask="true" key="deleteTransportCompany" ></p-confirmDialog>
